import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from './Select';
import { optionsPropTypes } from './SelectPropTypes';
import {
  clearBussesMaintenanceStay,
  getBusMaintenanceStaySearch,
} from '../../../../actions';
import { BUS_MAINTENANCE_STATUS_TYPE } from '../../../../config/constants';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_TIME_FORMAT } from '../../../../config/locale';

const BusMaintenanceStaySelect = ({
  options,
  loading,
  dispatchGetBusMaintenanceStaySearch,
  dispatchClearBusMaintenanceStaySearch,
  itineraryId,
  ...rest
}) => {
  useLayoutEffect(() => {
    dispatchGetBusMaintenanceStaySearch({ itineraryId });
    return () => {
      dispatchClearBusMaintenanceStaySearch();
    };
  }, []);

  const onInputChange = (selectedOption) => {
    if (!selectedOption) return;
    dispatchGetBusMaintenanceStaySearch({
      itineraryId,
      busMaintenanceStayId: selectedOption,
    });
  };

  return (
    <Select
      options={options}
      isLoading={loading}
      onInputChange={onInputChange}
      {...rest}
    />
  );
};

BusMaintenanceStaySelect.propTypes = {
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool,
  dispatchGetBusMaintenanceStaySearch: PropTypes.func.isRequired,
  dispatchClearBusMaintenanceStaySearch: PropTypes.func.isRequired,
  itineraryId: PropTypes.number.isRequired,
};

BusMaintenanceStaySelect.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  options: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'all',
    'content',
    'content',
  ]).map((busMaintenanceStay) => {
    const {
      id,
      registeredBus,
      originCity,
      destinationCity,
      maintenanceStayStatus,
      estimatedArrivalDate,
      estimatedCompletionDate,
    } = busMaintenanceStay;
    const statusName = BUS_MAINTENANCE_STATUS_TYPE[maintenanceStayStatus];
    const arrivalDate = estimatedArrivalDate
      ? tzNormalizeDate({
          date: estimatedArrivalDate,
          format: INT_DATE_TIME_FORMAT,
        })
      : null;
    const completionDate = estimatedCompletionDate
      ? tzNormalizeDate({
          date: estimatedCompletionDate,
          format: INT_DATE_TIME_FORMAT,
        })
      : null;
    return {
      label: `ID: ${id} | Bus: ${registeredBus.companyBusId} | Orig: ${
        originCity.name
      } | Dest: ${destinationCity ? destinationCity.name : '-'} | F. Llegada: ${
        arrivalDate || '-'
      } | F. Entrega: ${completionDate || '-'} | Estado: ${statusName || '-'}`,
      value: id,
    };
  }),
  loading: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'all',
    'loading',
  ]),
});

const mapDispatchToProps = {
  dispatchGetBusMaintenanceStaySearch: getBusMaintenanceStaySearch,
  dispatchClearBusMaintenanceStaySearch: clearBussesMaintenanceStay,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusMaintenanceStaySelect);
